import { render } from "./InterPoster.vue?vue&type=template&id=4ce9195f&ts=true"
import script from "./InterPoster.vue?vue&type=script&lang=ts"
export * from "./InterPoster.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/shunta/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__